import { MapPin } from 'lucide-react';

export default function MapSection() {
  return (
    <div className="bg-white border-t border-slate-100 py-14 lg:py-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider bg-emerald-50 text-emerald-800 border border-emerald-200/70 mb-3 shadow-2xs">
            <MapPin size={14} className="text-emerald-600" />
            <span>Our Location</span>
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-slate-900 tracking-tight mb-2">
            Find Us on the Map
          </h2>
          <p className="text-sm sm:text-base text-slate-500 max-w-xl mx-auto">
            Conveniently located in Udaipur for your wellness consultations and care.
          </p>
        </div>

        <div className="overflow-hidden rounded-2xl border border-slate-200/90 bg-white p-2 sm:p-2.5 shadow-sm hover:shadow-md transition-shadow">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3627.40215410196!2d73.70290637523873!3d24.60982057809385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3967e539768c0e07%3A0xf7b3822508deb32f!2sKvanta%20Labs%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1770112926388!5m2!1sen!2sin"
            title="Metafit Wellness Location"
            width="100%"
            height="420"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="rounded-xl w-full"
          />
        </div>
      </div>
    </div>
  );
}
